import {colorBank} from '../../../../../constants/ColorPicker';
import {Row} from './types';

export const COMMAND_PRIORITY_LOW = 1;

export const FONT_FAMILY_OPTIONS: [string, string][] = [
    ['Arial', 'Arial'],
    ['Courier New', 'Courier New'],
    ['Georgia', 'Georgia'],
    ['Times New Roman', 'Times New Roman'],
    ['Trebuchet MS', 'Trebuchet MS'],
    ['Verdana', 'Verdana']
];

export const FONT_SIZE_OPTIONS: [string, string][] = [
    ['10px', '10px'],
    ['11px', '11px'],
    ['12px', '12px'],
    ['13px', '13px'],
    ['14px', '14px'],
    ['15px', '15px'],
    ['16px', '16px'],
    ['17px', '17px'],
    ['18px', '18px'],
    ['19px', '19px'],
    ['20px', '20px']
];

export const URL_MATCHER =
    /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/;

export const DEFAULT_COLORS_MAP = [...new Set(colorBank.map((color: any) => color.hex))];

export const signature_placeholder = `
    <p>{date}</p>
    <p>&nbsp;</p>
    <p>Sincerely,</p>
    <p>Igor Lavskyi</p>
    <p>Front-End Dev</p>
    <p>E-mail: ihor.lavskyi@uptarget.co</p>
    <hr/>
    <p></p>
`;

export type Rows = Array<Row>;

export const cellHTMLCache: Map<string, string> = new Map();

export const cellTextContentCache: Map<string, string> = new Map();

export const emptyEditorJSON =
    '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}';
